namespace GeniuzPOS.Purchase {
    export interface PoParaRow {
        Id?: number;
        ToleranceTotal?: number;
        ToleranceVat?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PoParaRow {
        export const idProperty = 'Id';
        export const nameProperty = 'CreateBy';
        export const localTextPrefix = 'Purchase.PoPara';
        export const lookupKey = 'Purchase.PoPara';

        export function getLookup(): Q.Lookup<PoParaRow> {
            return Q.getLookup<PoParaRow>('Purchase.PoPara');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            ToleranceTotal = "ToleranceTotal",
            ToleranceVat = "ToleranceVat",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
